import React from 'react';

import { InlineAppletText, AppletTextContainer } from 'components/applets/components';
import useContentfulRenderer from 'hooks/useContentfulRenderer';
import { QuestApplet } from 'models/QuestApplet';
import { ChallengeApplet } from 'models/ChallengeApplet';
import { AppletContentful } from 'models/AppletContentful';

type InlineTextPreviewProps = {
  applet: QuestApplet | ChallengeApplet;
  appletDef: AppletContentful;
};

const InlineTextPreview = ({ applet, appletDef }: InlineTextPreviewProps) => {
  const renderedPrompt = useContentfulRenderer(appletDef.uploadPrompt);
  return (
    <AppletTextContainer>
      {renderedPrompt}
      <InlineAppletText>{applet.text}</InlineAppletText>
    </AppletTextContainer>
  );
};

export default InlineTextPreview;
